import { ApiResult, IVehicleResult, ICondition, IValuationRequest, IValuationResult, ILead } from '../types.d';

export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseAppUrl = process.env.REACT_APP_BASE_APP_URL;
export const baseStoreAppUrl = process.env.REACT_APP_BASE_STORE_APP_URL;

export const validateEmail = async (email: string): Promise<boolean> => {
  if (new RegExp(/^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/).test(email)){
    const url = `${baseStoreAppUrl}/api/sensisproxy?path=%2Femail%3Femail_address%3D${encodeURIComponent(email)}`;
    const r = await apiFetchGETUTF16(url);
    return r.status == 'OK' && r.result && 
      r.result.email_valid == 'VALID' && 
      r.result.domain_exists == 'VALID' && 
      r.result.mailserver_exists == 'VALID'
    ;
  }
  return false;
}

export const validatePhone = async (phone: string): Promise<boolean> => {
  if (new RegExp(/^04[0-9]{8}$/).test(phone)){
    const url = `${baseStoreAppUrl}/api/sensisproxy?path=%2Fphone%3Fnumber%3D${phone}`;
    const r = await apiFetchGETUTF16(url);
    return r.status == 'OK' && r.result && r.result.phone_status == "Active";
  }
  else return false;
}

export const getConditions = async (): Promise<ApiResult<ICondition[]>> => {
  const result = await apiFetchGET(`${baseUrl}/vehiclecondition`);
  return result;
};
export const getVehicles = async (rego: string, state: string, captcha: string): Promise<ApiResult<IVehicleResult[]>> => {
  const result = await apiFetchGET(`${baseUrl}/vehicle/${rego}/${state}/${captcha}`);
  return result;
};
export const getDealerInfo = async (dealerId: number) => {
  const result = await apiFetchGET(`${baseAppUrl}/api/DealerInfo?id=${dealerId}&includeOpeningTimesForNewDepartment=true`);
  return result;
};
export const postValuation = async ( request : IValuationRequest ): Promise<ApiResult<IValuationResult>> => {
  const result = await apiFetchPostJson(`${baseUrl}/valuation`, request);
  return result;
};
export const postVehicleLead = async (request: ILead): Promise<ApiResult<any>> => {
  const result = await apiFetchPostJson(`${baseStoreAppUrl}/instantOffer/v1`, request);
  return result;
};
export const getAcceptOffer = async (offerID: string, redbookCode: string): Promise<ApiResult<boolean>> => {
  const result = await apiFetchGET(`${baseStoreAppUrl}/instantOffer/v1/accept?id=${offerID}&redbookcode=${redbookCode}`);
  return result;
};
const apiFetchGETUTF16 = async(url: string): Promise<any> => {
  try {
    const result = await fetch(url, {
      method: 'GET'
    }).then((data) => {
      if (data.ok){
        return data.arrayBuffer();
      }
    }).then((data) => {
      return new TextDecoder("utf-16le").decode(data);
    });
    console.log('result',result);
    return JSON.parse(result);
  }
  catch (e){
    console.log(e);
    return { errormessage: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.' };
  }
};
const apiFetchGET  = async (url: string): Promise<any> => {
  try {
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *client
    });
    var end = new ApiResult<any>();
    var ok = await response.ok;
    if (ok) {
      end.result = await response.json();
      end.errormessage = '';
    } else {
        end.result = []
        end.errormessage = response.status == 500 ? '' : await response.text();
    }
    return end;
  }
  catch (e){
    console.log(e);
    return { errormessage: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.' };
  }
};
const apiFetchPostJson = async (url: string, body: any): Promise<any> => {
  try {
    const response = await fetch(url, {
      method: 'Post',
      mode: 'cors',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    var end = new ApiResult<any>();
    var ok = await response.ok;
    if (ok) {
      end.result = await response.json();
      end.errormessage = '';
    } else {
      end.result = [];
      end.errormessage = response.status == 500 ? '' : await response.text();
    }
    return end;
  } 
  catch (e){
    console.log(e);
    return { errormessage: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.' }
  }
};
